import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { fetchAdminNoticeList } from '../../../api/admin.notice';
import { AdminSearchComponent } from '../../../components/admin/admin.search';
import { AdminNoticeTableComp } from './admin.notice.table';

interface FetchAdminNoticeParams {
  title?: string;
}

interface NoticeDtoRx {
  noticeId: number;
  title: string;
  createdAt: string;
  viewCount: number;
}

const AdminNoticeList = () => {
  const [noticeList, setNoticeList] = useState<NoticeDtoRx[] | null>(null);
  const [searchParams, setSearchParams] = useState<FetchAdminNoticeParams>({});

  useEffect(() => {
    const getNoticeList = async () => {
      try {
        const response = await fetchAdminNoticeList(searchParams);
        setNoticeList(response);
      } catch (error) {}
    };

    getNoticeList();
  }, [searchParams]);

  // 검색 필터 값 변경을 처리하는 함수
  const handleSearchChange = (params: FetchAdminNoticeParams) => {
    setSearchParams(params); // 필터 값을 업데이트하여 API 호출을 트리거함
  };

  return (
    <Container>
      <AdminSearchComponent
        handleSearchChange={handleSearchChange}
        searchType="onlyTitle"
      />
      {noticeList ? (
        <AdminNoticeTableComp
          data={noticeList || []}
          setNoticeList={setNoticeList}
        />
      ) : null}
    </Container>
  );
};

export default AdminNoticeList;

// style
const Container = styled.div``;
